import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'
import { FormBuilder, FormGroup } from '@angular/forms'

@Component({
  selector: 'app-origin-compose',
  templateUrl: './compose.component.html',
  styleUrls: ['./compose.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OriginDialogComponent implements OnInit {
  composeForm: FormGroup

  constructor(
    public dialogRef: MatDialogRef<OriginDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,
  ) {
    this.composeForm = this.createComposeForm()
  }

  ngOnInit() {}

  createComposeForm() {
    return this.formBuilder.group({
      name: [''],
      description: [''],
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/system/origins/dialogs/compose/compose.component.ts